import { useContext } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, TableFooter, Typography, TablePagination, Grid } from '@material-ui/core';
import { customersContext } from '../CustomersContext';
import { DeleteIconButton, EditIconButton } from 'components';
import GeneratePassword from './GeneratePassword';


let Results = () => {
    let service = useContext(customersContext);

    return (
        <Grid container>
            <Grid item xs>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Email</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Company</TableCell>
                            <TableCell>M3 Id</TableCell>
                            <TableCell>Cognito</TableCell>
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {service.customers.map((customer, index) =>
                            <TableRow hover key={index}>
                                <TableCell>{customer.email}</TableCell>
                                <TableCell>{customer.name}</TableCell>
                                <TableCell>{customer.companyName}</TableCell>
                                <TableCell>{customer.m3Id}</TableCell>
                                <TableCell>{customer.existOnCognito === false && 'Account missing from Cognito'}</TableCell>
                                <TableCell align="right">
                                    {customer.existOnCognito === true &&
                                        <>
                                            <GeneratePassword email={customer.email} />
                                            <EditIconButton link={`/admin/customer/${customer.id}`} />
                                        </>
                                    }
                                    <DeleteIconButton onClick={() => service.deleteCustomer(customer.id)} stopPropagation />
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                    {service.customers.length === 0 &&
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={6}>
                                    <Typography variant="subtitle2">No customers found</Typography>
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    }
                </Table>
                <TablePagination
                    rowsPerPageOptions={[service.search.pageSize]}
                    component="div"
                    count={service.recordCount}
                    rowsPerPage={service.search.pageSize}
                    page={service.search.pageNr}
                    backIconButtonProps={{ 'aria-label': 'Previous Page' }}
                    nextIconButtonProps={{ 'aria-label': 'Next Page' }}
                    onPageChange={(e, page) => service.changePage(page)}
                    labelDisplayedRows={({ page }) =>
                        <span>Found {service.recordCount} customers&nbsp;&middot;&nbsp;page {page + 1} of {Math.ceil(service.recordCount / service.search.pageSize)}</span>
                    }
                />
            </Grid>
        </Grid>
    );
}

export default Results;